"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getScaledScoreForRawScore(rawScore, minScore, maxScore) {
    return maxScore - minScore > 0 ? (rawScore - minScore) / (maxScore - minScore) : 0;
}
exports.getScaledScoreForRawScore = getScaledScoreForRawScore;
//# sourceMappingURL=getScaledScoreForRawScore.js.map